/*
 * @Descripttion: 
 * @version: 
 * @Author: Blau
 * @Date: 2023-10-17 17:40:00
 * @LastEditors: Andy
 * @LastEditTime: 2023-10-23 10:30:39
 */
const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  resources: state => state.user.resources,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js